import { NgModule } from '@angular/core';
import { MdlModule } from '@angular-mdl/core';
import { MdlSelectModule } from '@angular-mdl/select';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from "@angular/material";
import { MatDatepickerModule, MatNativeDateModule, MatIconModule } from "@angular/material";
import { SignaturePadModule } from 'angular2-signaturepad';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { MbscModule, mobiscroll } from '@mobiscroll/angular';
import { AccordionModule } from "ngx-accordion";

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { VirtualConsultationRoutingModule } from './virtual-consultation-app-routing.module';
import { CopyrightFooterModule } from './shared/components/copyright-footer/copyright-footer.module';
import { TranslateModule } from './translate/translate.module';
import { PipeModule } from './pipes/pipes.module';
import { DirectivesModule } from './directives/directives.module';
import { ImageCropperModule } from './shared/modules/image-cropper.module';
import { NotFoundModule } from './404/notFound.module';

import { BaseWebService } from './shared/services/base-web.service';
import { SharedService } from './shared/services/shared.service';
import { SessionStorageService } from './shared/services/session-storage.service';
import { AuthResolver } from './shared/services/auth.resolver';
import { LoggedInResolver } from './shared/services/loggedIn.resolver';
import { TranslateService } from './translate/translate.service';
import { ValidationService } from './shared/services/validation.service';
import { RestrictOutsideScrollService } from "./shared/services/restrict-outside-scroll.service";
import { UtilService } from './shared/services/util.service';

import { VirtualCOnsultationAppComponent } from './virtual-consultation-app.component';

import { VCStartPageComponent } from './virtual-consultation-start-page/virtual-consultation-start-page.component';
import { VCProgressCheckupComponent } from './virtual-consultation-progress-checkup/virtual-consultation-progress-checkup.component';
import { VCRetainerCheckupComponent } from './virtual-consultation-retainer-checkup/virtual-consultation-retainer-checkup.component';
import { VCPhotoUploadComponent } from './virtual-consultation-photo-upload/virtual-consultation-photo-upload.component';
import { VCSuccessPageComponent } from './virtual-consultation-success-page/virtual-consultation-success-page.component';
import { VCEmergencyCheckupComponent } from "./virtual-consultation-emergency-checkup/virtual-consultation-emergency-checkup.component";
import { VCPatientDetailsComponent } from './virtual-consultation-patient-details/virtual-consultation-patient-details.component';
import { VCNewPatientComponent} from './virtual-consultation-new-patient/virtual-consultation-new-patient.component';
import { OrthoFooterComponent } from './shared/components/ortho-footer/ortho-footer.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

// Default date picker config
mobiscroll.settings = {
  theme: 'ios',
  themeVariant: 'light',
  display: 'bottom',
  returnFormat: 'locale',
  max: new Date(),
  closeOnOverlayTap: false,
  showOnFocus: false,
  showOnTap: false,
  defaultValue: new Date("01/01/2000")
};

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    MdlModule,
    MdlSelectModule,
    VirtualConsultationRoutingModule,
    HttpModule,
    MatDialogModule,
    TranslateModule,
    PipeModule,
    CopyrightFooterModule,
    DirectivesModule,
    SignaturePadModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ImageCropperModule,
    MatIconModule,
    NotFoundModule,
    DeviceDetectorModule.forRoot(),
    SwiperModule,
    MbscModule,
    AccordionModule
  ],
  declarations: [
      VCStartPageComponent,
      VCProgressCheckupComponent,
      VCRetainerCheckupComponent,
      VCPhotoUploadComponent,
      VCPatientDetailsComponent,
      VCSuccessPageComponent,
      VirtualCOnsultationAppComponent,
      VCNewPatientComponent,
      VCEmergencyCheckupComponent,
      OrthoFooterComponent,
  ],
  providers: [
    BaseWebService,
    SharedService,
    SessionStorageService,
    LoggedInResolver,
    AuthResolver,
    ValidationService,
    RestrictOutsideScrollService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
    { provide: 'utilService', useClass: UtilService }
  ],
  bootstrap: [VirtualCOnsultationAppComponent]
})

export class VirtualConsultationModule {
  constructor(
    private _translate: TranslateService,
    private _sessionStorageService: SessionStorageService,
  ) {
    this._sessionStorageService.readItem('language').then((data: any) => {
      if(data) {
          this._translate.use(data.lang);
      } else {
          this._translate.use('en');
      }
});
  }
}



// bootstrap: [PracticeAppComponent]
// })
// export class PracticeAppModule { }
